// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"805cf7a4","248":"0082705b","356":"e212308c","458":"30924233","495":"f970d4c9","623":"8ace1bef","666":"a98e8a10","897":"6023ce71","942":"73e859b2"}[chunkId] + ".chunk.js";
};